import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { Link, useParams } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa';
import styles from './../../Assets/CSS/Modal.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { BlueButton } from './../../Components/Button';

function ListingImage() {
    const { id } = useParams();
    const accessToken = localStorage.getItem('accessToken');
    const [create, setCreate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [image, setImage] = useState([]);
    function onGetData() {
        setIsLoading(true);
        axios.post(`${BASE_URL}/vendor/listing/image`, { id }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            setImage(res.data.data);
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }
    useEffect(() => {
        document.title = 'Infomart | Client Listing Image';
        onGetData();
    }, []);
    const onDeleteData = async (id) => {
        const confirmed = window.confirm('Are you sure you want to delete this data?');
        if (confirmed) {
            await axios.post(`${BASE_URL}/vendor/listing/image/delete`, { id }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                toast.success(res.data.msg, { autoClose: 3000 });
                onGetData();
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
            });
        }
    }
    const handleCreate = () => {
        if (image.length > 15) { 
            toast.error('You can upload 15 image only.');
        } else { 
            setCreate(true);
        } 
    }
    const onClose = () => {
        setCreate(false);
    }
    const [upload_image, setUploadImage] = useState('');
    const [isImageLoading, setIsImageLoading] = useState(false);
    const handleChangeImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadImage(file); 
        } 
    }
    const handleImage = async () => {
        setIsImageLoading(true);
        if (upload_image) {
            const formData = new FormData(); 
            formData.append('id', id);
            formData.append('file', upload_image); 
            await axios.post(`${BASE_URL}/vendor/listing/image/create`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => {
                onGetData();
                setCreate(false);
                toast.success(res.data.msg, { autoClose: 3000 });
                setIsImageLoading(false);
            }).catch((res) => {
                toast.error(res.response.data.msg, { autoClose: 3000 });
                setIsImageLoading(false);
            });
        } else {
            toast.error('Select your image first.', { autoClose: 3000 });
            setIsImageLoading(false);
        }
    }
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5>
                    : 
                        <div className="card">
                            <div className="card-header fw-bold">
                                Listing Image
                                <Link className="float-end text-decoration-none" onClick={handleCreate}>Create New</Link>
                                {create ?
                                    <div className={styles.successModalContainer}>
                                        <div className={styles.closeBtn} onClick={onClose}>&times;</div>
                                        <h4 className="mb-4">Upload Image</h4>
                                        <h5 className="mb-2">Image *</h5>
                                        <input type="file" className={inputStyles.input} accept="image/*" onChange={(e) => handleChangeImage(e)} />
                                        <small className="text-muted">Recommended Size: 262 x 262 Pixels</small> 
                                        <br /> 
                                        <div className={styles.row}>
                                            <BlueButton title={isImageLoading ? "Loading..." : "Submit"} onClick={() => handleImage()} />
                                        </div>
                                    </div>
                                : null } 
                            </div> 
                            <div className="card-body">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Image</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="align-middle">
                                        {image && image.length > 0 ? (
                                            image.map((data, i) => (
                                                <tr key={i}>
                                                    <th scope="row">{i + 1}</th>
                                                    <td><img src={BASE_FILE_URL + data.image} className="img-thumbnail" height={120} width={120} /></td>
                                                    <td>
                                                        <button className="btn btn-danger btn-sm" onClick={() => onDeleteData(data.id)}><FaTrash /></button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <th colSpan="3" className="text-center">No data available.</th>
                                            </tr> 
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            </div> 
        </div>
    );
}

export default ListingImage;            